module.exports = __webpack_public_path__ + "static/media/we-are-never-meeting-in-real-life.e1b33f19.jpg";